<template>
    <div class="flex flex-col flex-1">
        <question-header :question="question" :instructions="instructions" :required="required" class="mb-6 md:mb-10"/>

        <div class="flex flex-col flex-1">
            <div class="flex flex-col flex-1 justify-center">
                <template v-if="options">
                    <label v-for="(option, index) in options"
                           :key="`label_${index}`"
                           class="block text-muted-500 font-bold text-base md:text-lg mb-3 md:mb-6">
                        {{ option | trans }}
                        <input class="block w-full border bg-light-200 border-light-300 rounded-full py-1 sm:py-2 md:py-4 px-3 md:px-6 focus:outline-none text-muted-500 font-bold focus:bg-transparent focus:border-lightGrey-200 mb-4 mt-3"
                               type="text"
                               :key="`input_${index}`"
                               v-model="value[index]">
                    </label>
                </template>

                <label v-else="!options"
                       class="block text-muted-500 font-bold text-base md:text-lg mb-3 md:mb-6">
                    <input class="block w-full border bg-light-200 border-light-200 rounded-full py-1 sm:py-2 md:py-4 px-3 md:px-6 focus:outline-none text-muted-500 font-bold focus:bg-transparent focus:border-lightGrey-200 mb-4 mt-3"
                       type="text"
                       v-model="value[0]">
                </label>
            </div>

            <div v-if="errorMessage" class="w-full py-1 sm:py-2 md:py-3 pl-6 mt-8 md:mt-12 bg-risk-400 rounded-full text-center text-base md:text-2xl text-light-100">
                {{ errorMessage }}
            </div>
        </div>
    </div>
</template>

<script>
    import QuestionHeader from './QuestionHeader';

    export default {
        components: {
            QuestionHeader
        },

        props: {
            question: {
                type: Object,
                required: true
            },
            options: {
                type: Array,
            },
            required: {
                type: Boolean,
                required: true
            },
            instructions: Object,
            answer: Array
        },
        data() {
            let value = [];
            (this.options || [1]).forEach(o => value.push(''));

            return {
                value,
                errorMessage: null
            }
        },
        watch: {
            value(data) {
                const answers = [];
                data.forEach((answer, index) => answers.push({
                    index,
                    value: answer
                }));
                this.$emit('input', answers);
            }
        },
        methods: {
            validate() {
                if (!this.required) {
                    return true;
                }

                let valid = !!this.value[0].length;

                if (this.options) {
                    valid = !this.value.filter(val => !val.length).length;

                    this.errorMessage = !valid ? "All fields are required!" : null;
                    return valid;
                }

                this.errorMessage = !valid ? "This field is required!" : null;
                return valid;
            }
        },
        mounted() {
            this.answer.forEach(v => this.$set(this.value, v.index, v.value));
        }
    }
</script>
